<!-- 실시간 게시글 랭킹 -->
<template>
    <div class="userRank_wrap">
        <div class="loading-spinner" v-if="isLoading">
            <base-spinner></base-spinner>
        </div>
        <div v-else class="ranktable">
            <div class="title">
                <img src="@/assets/imgs/icon/star.png"> &nbsp;인기글&nbsp;
            </div>
            <table>
                <thead>
                    <tr>
                        <th class="ranking">순위</th>
                        <th class="subject">제목</th>                       
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(rank, index) in postRank" :key="index">
                        <td class="ranking">{{index+1}}</td>
                        <td class="subject">  <post-content :post="rank" titlelength=20  :imgview="false" :isDocView="true"/></td>                       
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>
<script>

import PostContent from '@/components/posts/PostContent';
export default {
    name:'PostRanking',
    mixins:[  ],
    data(){
        return{
            isLoading:true,
            postRank:[]
        }
    },
    components:{
       PostContent
    },
    mounted() {
        this.getPostRank();
    },
    methods:{
        async getPostRank() {
            try {
                const response = await this.$store.dispatch("posts/getPostRanking")
                
                this.postRank = response;
                //console.log("안나오는듯",this.postlists.data.length);
            }catch(error){
                console.log(error.response);
            }
            this.isLoading = false;
        },
    }
}
</script>
<style lang="scss" scoped>
.userRank_wrap{
    border:1px solid #dee3eb;
    padding:20px;
    background:#fff;
    font-family: '맑은고딕';
    .ranktable{
        .title{
            padding-bottom:10px;
            text-align: center;
            font-weight: bold;
            font-size:16px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: dotted 1px #ccc;
        }
        table{
            width:100%;
            th,td{padding:5px;}
            th{padding-bottom:20px;}
            .ranking{text-align:center;}
            .subject{
                text-align: left;display: flex;align-items: center;
                span{
                    margin-left:5px;
                }
            }
            .point{text-align:right;}
            tbody{
                tr:nth-child(-n+3){
                    font-weight: bold;
                }
            }
        }
    }
}
</style>
